import { styled } from '../../../../../utils/styled';
import { propStyles } from '../../../../../utils/propStyles';
import ToastBase from './ToastBase';

const StyledComponent = styled<any, any>(
    ToastBase,
    'toastWarning',
    'feedback-toast'
)`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    backgroundColor: '#fff3cd',
    color: '#856404',
    borderColor: '#ffeeba',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/StyledComponents/ToastWarning.tsx